var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: true,
          searchBaseItems: [
            "sellerId",
            "shiftDate",
            "createdAtStart",
            "createdAtEnd",
            "giftGoodsName"
          ],
          btns: { search: true, reset: true, download: _vm.downloading }
        },
        on: { onChange: _vm.onSearchChange }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "45rem"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "站点", prop: "sellerName" }
          }),
          _c("el-table-column", {
            attrs: { label: "商品", prop: "giftGoodsName" }
          }),
          _c("el-table-column", {
            attrs: { label: "类目", prop: "categoryName" }
          }),
          _c("el-table-column", {
            attrs: { label: "订单数量", prop: "totalOrderNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "销量(个)", prop: "totalGoodsNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "应收(元)", prop: "totalOrderSaleAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "优惠(元)", prop: "totalOrderDiscount" }
          }),
          _c("el-table-column", {
            attrs: { label: "实收(元)", prop: "totalTradePay" }
          }),
          _c("el-table-column", {
            attrs: { label: "成本(元)", prop: "totalGoodsCost" }
          }),
          _c("el-table-column", {
            attrs: { label: "毛利(元)", prop: "grossProfit" }
          }),
          _c("el-table-column", {
            attrs: { label: "毛利率(%)", prop: "grossMargin" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.grossMargin) + "%")]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }